import React from "react";
import styles from "./DetailRow.module.css";

export interface DetailRowProps {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  trailingIcon?: React.ReactNode;
  multiline?: boolean;
  className?: string;
  onClick?: () => void;
}

const DetailRow: React.FC<DetailRowProps> = ({
  icon,
  label,
  value,
  trailingIcon,
  multiline = false,
  className = "",
  onClick,
}) => {
  return (
    <div className={`${styles.field} ${className}`}>
      <div className={styles.labelWrapper}>
        <span className={styles.iconFill}>{icon}</span>
        <span className={styles.label}>{label}</span>
      </div>
      {onClick ? (
        <button
          type="button"
          className={`${styles.valueRow} ${styles.valueRowClickable} ${
            multiline ? styles.multiline : ""
          }`}
          onClick={onClick}
        >
          <span className={styles.value}>{value}</span>
          {trailingIcon && (
            <span className={styles.trailingIcon}>{trailingIcon}</span>
          )}
        </button>
      ) : (
        <div
          className={`${styles.valueRow} ${multiline ? styles.multiline : ""}`}
        >
          <span className={styles.value}>{value}</span>
          {trailingIcon && (
            <span className={styles.trailingIcon}>{trailingIcon}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default DetailRow;
